import getSymbolFromCurrency from 'currency-symbol-map';
import i18n from 'i18n/config';

export const formatNumber = (value: number, decimalPlaces: number, shouldUseBrackets = false, disableLocaleFormatting = false):string => {
  const absolute = Math.abs(value);
  const currentLang = i18n.language;
  const euFormat = !currentLang.toLowerCase().startsWith('en') && !disableLocaleFormatting;

  if (value || value === 0) {
    if (shouldUseBrackets && (Math.sign(value) === -1)) {
      const result = absolute?.toLocaleString(
        euFormat ? 'de-DE' : 'en-US', { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces },
      );
      return `(${result})`;
    }
    return value?.toLocaleString(euFormat ? 'de-DE' : 'en-US', { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces });
  }

  return '';
};

export const formatCurrency = (currency: string | undefined, value: number | undefined, shouldUseBrackets = false):string => {
  if (currency && (value || value === 0)) {
    const symbol = getCurrencySymbol(currency);
    return `${symbol}${formatNumber(value, 2, shouldUseBrackets)}`;
  } return '-';
};

export const getCurrencySymbol = (currency?: string): string => {
  if (currency) {
    const currencyCode = (currency === 'CNH') ? 'CNY' : currency;
    const symbol = getSymbolFromCurrency(currencyCode) || '';
    return symbol;
  }
  return '';
};

export const splitCurrencyPair = (currencyPair: string): string[] => currencyPair?.split('/', 2);
